import { queryUser } from '@/api/user'
import * as T from '@/core/configs/types'
import { Container } from './container'
import { Note, NoteForm } from './note'
import { Order } from './order'
import { getYearsPrependOptions } from '@/core/utils/date'
import {
  NormalPallet,
  MediumPallet,
  HighPallet,
  Pallet,
  PalletStatus
} from '@/core/models/pallet'
import {
  JobStatus,
  UnloadingJob,
  JobTypes,
  JobUnassigned,
  JobProcessing,
  JobAssigned,
  JobDeleted,
  JobCompleted,
  CBM_PER_PALLET,
  SplitPalletJob
} from './constant'
import { AddressBook } from './address'
import { appendBefore } from '../utils'

export const GoodsGroup = {
  name: {
    type: T.Text,
    label: 'Group',
    key: 'name'
  },
  goods: {
    type: T.Array,
    itemType: T.String,
    key: 'goods'
  },
  cmb: {
    type: T.Number,
    label: 'Total CBM',
    key: 'cmb'
  },
  quantity: {
    type: T.Number,
    label: 'Estimated QTY.',
    key: 'quantity'
  },
  actualQuantity: {
    type: T.Number,
    label: 'Actual QTY.',
    key: 'actualQuantity'
  },
  palletCount: {
    type: T.Number,
    label: 'Pallet CNTs',
    key: 'palletCount'
  },
  actualPalletCount: {
    type: T.Number,
    label: 'Actual Pallet CNTs',
    key: 'actualPalletCount'
  },
  address: {
    type: T.Ref,
    ref: AddressBook,
    label: 'Address',
    key: 'address'
  },
  notes: {
    type: T.Text,
    label: 'Note',
    key: 'notes'
  },
  hold: {
    type: T.Boolean,
    label: 'Hold',
    key: 'hold'
  },
  priority: {
    type: T.Enum,
    label: 'Priority',
    key: 'priority',
    options: [NormalPallet, MediumPallet, HighPallet]
  }
}

export const Job = {
  id: {
    type: T.String,
    label: 'Job ID',
    key: 'id',
    col: 'job_id'
  },
  no: {
    type: T.String,
    label: 'Job No.',
    key: 'no',
    col: 'job_no'
  },
  type: {
    type: T.Enum,
    label: 'Job Type',
    key: 'type',
    options: Object.values(JobTypes),
    col: 'job_type'
  },
  status: {
    type: T.Enum,
    label: 'Job Status',
    key: 'status',
    options: Object.values(JobStatus),
    col: 'job_status'
  },
  orderId: {
    type: T.Text,
    label: 'order id',
    key: 'orderId',
    col: 'order_id'
  },
  unloadingJobId: {
    type: T.Text,
    label: 'unloading job id',
    key: 'unloadingJobId',
    col: 'unloading_job_id'
  },
  shipmentId: {
    type: T.Text,
    label: 'Shipment id',
    key: 'shipmentId',
    col: 'shipment_id'
  },
  assigneeId: {
    type: T.String,
    label: 'Assigned Worker',
    key: 'assigneeId',
    col: 'assignee_id'
  },
  assigneeName: {
    type: T.String,
    label: 'Assigned Worker',
    key: 'assigneeName',
    col: 'assignee_name'
  },
  portId: {
    type: T.String,
    label: 'Port Id',
    key: 'portId',
    col: 'port_id'
  },
  portNo: {
    type: T.String,
    label: 'Port No',
    key: 'portNo',
    col: 'port_no'
  },
  goodsGroups: {
    type: T.Array,
    itemType: GoodsGroup,
    label: 'Unloading Groups',
    key: 'goodsGroups'
  },
  notes: {
    type: T.Array,
    ref: Note,
    label: 'Note',
    key: 'notes'
  },
  createdTime: {
    type: T.Time,
    label: 'Created on',
    key: 'createdTime',
    col: 'job_created_time'
  },
  updatedTime: {
    type: T.Time,
    label: 'Updated on',
    key: 'updatedTime',
    col: 'job_updated_time'
  }
}

export const JobAssignedItem = {
  ...Job.assigneeId,
  span: 1,
  type: T.RemoteSelect,
  options: [],
  loading: false,
  method: function (name) {
    const that = this
    that.loading = true
    queryUser({ name }).then(res => {
      that.loading = false
      that.options.splice(0, that.options.length)
      this.options.push(
        ...res.map(item => ({
          key: item.id,
          label: item.username,
          value: item.id
        }))
      )
    })
  },
  example: 'MC',
  default: '',
  value: '',
  validators: [T.RequiredValidator]
}

export const JobForm = Object.fromEntries(
  [
    {
      type: T.Text,
      label: 'RII Order No',
      key: 'riiOrderNo',
      span: 1,
      value: '',
      validators: []
    },
    {
      ...Job.type,
      span: 1,
      type: T.Tag,
      effect: 'dark',
      example: UnloadingJob,
      default: UnloadingJob,
      value: UnloadingJob,
      validators: [T.RequiredValidator]
    },
    // { ...JobAssignedItem },
    // {
    //   ...Job.assigneeId,
    //   span: 1,
    //   type: T.RemoteSelect,
    //   options: [],
    //   loading: false,
    //   method: function (name) {
    //     const that = this
    //     that.loading = true
    //     queryUser({ name }).then(res => {
    //       that.loading = false
    //       that.options.splice(0, that.options.length)
    //       this.options.push(
    //         ...res.map(item => ({
    //           key: item.id,
    //           label: item.username,
    //           value: item.id
    //         }))
    //       )
    //     })
    //   },
    //   example: 'MC',
    //   default: '',
    //   value: '',
    //   validators: []
    // },
    ...NoteForm
  ].map(one => [one.key, one])
)

export const JobModifyForm = Object.fromEntries(
  [
    {
      ...Job.no,
      type: T.Text,
      span: 1,
      value: '',
      validators: []
    },
    {
      ...Job.type,
      span: 1,
      type: T.Tag,
      effect: 'dark'
    },
    {
      ...Job.status,
      type: T.Tag,
      span: 1
    },
    {
      type: T.Text,
      label: 'RII Order No',
      key: 'riiOrderNo',
      span: 1,
      value: '',
      validators: []
    }
    // { ...JobAssignedItem }
    // {
    //   ...Job.assigneeId,
    //   span: 1,
    //   type: T.RemoteSelect,
    //   options: [],
    //   loading: false,
    //   method: function (name) {
    //     const that = this
    //     that.loading = true
    //     queryUser({ name }).then(res => {
    //       that.loading = false
    //       that.options.splice(0, that.options.length)
    //       this.options.push(
    //         ...res.map(item => ({
    //           key: item.id,
    //           label: item.username,
    //           value: item.id
    //         }))
    //       )
    //     })
    //   },
    //   default: '',
    //   value: '',
    //   validators: []
    // }
  ].map(one => [one.key, one])
)

const JobInfoPicks = [
  { ...Job.no, type: T.Text, span: 1 },
  {
    type: T.Text,
    label: 'Assignee',
    key: 'assigneeName',
    span: 1
  },
  { ...Job.status, type: T.Tag, effect: 'dark', span: 1 },
  { ...Job.type, type: T.Tag, effect: 'plain', span: 1 },
  { ...Order.riiOrderNo, type: T.Text, span: 1 },
  { ...Job.portNo, type: T.Tag, effect: 'plain', span: 1 },
  { ...Container.containerNo, type: T.Text, span: 1 },
  { ...Job.createdTime, type: T.Time, span: 1 },
  { ...Job.updatedTime, label: 'Last Update', type: T.Time, span: 1 }
]

export const JobInfoWrapUp = T.generateWrapUp(JobInfoPicks)

export const GoodsGroupForm = [
  {
    key: 'address',
    label: 'Deliver Address',
    type: T.AddressSelect,
    value: null,
    validators: []
  },
  {
    ...GoodsGroup.name,
    label: 'Group name',
    type: T.TextInput,
    value: 'xxx',
    validators: [T.RequiredValidator]
  },
  {
    ...GoodsGroup.hold,
    label: 'Hold',
    type: T.HoldSelect,
    value: false,
    activeText: 'Yes',
    inactiveText: 'No',
    validators: [T.RequiredValidator]
  },
  {
    ...GoodsGroup.priority,
    label: 'Priority',
    type: T.Select,
    options: [NormalPallet, MediumPallet, HighPallet],
    value: NormalPallet,
    validators: [T.RequiredValidator]
  }
]

export const GoodsGroupWrapUp = (group, goodsList) => {
  const category = {}
  category[GoodsGroup.name.key] = group.name
  category[GoodsGroup.address.key] = group.address
  const quantity = goodsList.reduce((prev, cur) => {
    return prev + cur.quantity
  }, 0)
  category[GoodsGroup.quantity.key] = quantity
  const cmb = goodsList.reduce((prev, cur) => {
    return prev + cur.cmb
  }, 0)
  category[GoodsGroup.cmb.key] = parseFloat(cmb).toPrecision(3)
  category.comment = ''
  category.goodsList = goodsList
  category[GoodsGroup.hold.key] = group.hold
  category[GoodsGroup.palletCount.key] = Math.ceil(cmb / CBM_PER_PALLET)
  category[GoodsGroup.priority.key] = group.priority
  return category
}

export const UnloadingJobContentHeaders = [
  {
    ...GoodsGroup.name
  },
  {
    type: T.AddressTag,
    label: 'Address',
    key: 'address'
  },
  { ...GoodsGroup.hold, type: T.HoldTag, width: 60 },
  {
    ...GoodsGroup.priority,
    type: T.Tag,
    width: 60
  },
  GoodsGroup.quantity,
  {
    ...GoodsGroup.cmb,
    width: 70
  },
  {
    ...GoodsGroup.palletCount,
    label: 'Est Pallet CNTs'
  },
  GoodsGroup.actualQuantity,
  {
    ...GoodsGroup.actualPalletCount,
    width: 100
  }
]

export const UnloadingJobSearchForm = [
  {
    label: 'RII Order NO.(after OTRII)',
    key: 'fuzzyRiiOrderNo',
    type: T.TextInput,
    inputAccept: 'number',
    example: 'OTRII2022110101',
    default: '',
    value: '',
    validators: [],
    convertor: (header, value) => {
      return header.prependValue + value
    },
    prepend: T.PrependText,
    prependValue: 'OTRII'
  },
  {
    label: 'RII Container No.',
    key: 'fuzzyRiiContainerNo',
    type: T.TextInput,
    example: 'C-23-0190',
    inputAccept: 'number',
    default: '',
    value: '',
    validators: [],
    convertor: (header, value) => {
      if (!value) return undefined
      return header.prependValue + appendBefore(4, '0', value)
    },
    prepend: T.PrependSelect,
    prependValue: getYearsPrependOptions('C')[0].value,
    prependOptions: getYearsPrependOptions('C')
  },
  {
    label: 'Job No. (eg: J-23-0200)',
    key: 'fuzzyJobNo',
    type: T.TextInput,
    example: '',
    default: '',
    value: '',
    validators: [],
    convertor: (header, value) => {
      return header.prependValue + value
    },
    prepend: T.PrependSelect,
    prependValue: getYearsPrependOptions('J')[0].value,
    prependOptions: getYearsPrependOptions('J')
  },
  {
    ...Container.containerNo,
    type: T.TextInput,
    example: '',
    default: '',
    value: '',
    validators: [],
    convertor: T.DefaultConvertor
  },
  {
    label: 'Job Status',
    key: 'statusList',
    type: T.Select,
    multiple: true,
    example: [],
    default: Object.keys(JobStatus),
    value: [JobUnassigned, JobAssigned, JobProcessing],
    options: Object.values(JobStatus),
    validators: [T.RequiredNotEmptyListValidator],
    convertor: T.DefaultConvertor
  },
  {
    type: T.TimeRange,
    key: 'createdTimeRange',
    label: 'Created Time',
    value: [],
    validators: [],
    convertor: T.DefaultConvertor
  }
]

export const JobSearchForm = [
  {
    label: 'Job No. (eg: J-23-0200)',
    key: 'fuzzyJobNo',
    type: T.TextInput,
    example: '',
    default: '',
    value: '',
    validators: [],
    convertor: (header, value) => {
      return header.prependValue + value
    },
    prepend: T.PrependSelect,
    prependValue: getYearsPrependOptions('J')[0].value,
    prependOptions: getYearsPrependOptions('J')
  },
  {
    label: 'Job Status',
    key: 'statusList',
    type: T.Select,
    multiple: true,
    example: [],
    default: Object.keys(JobStatus),
    value: [JobUnassigned, JobAssigned, JobProcessing],
    options: Object.values(JobStatus),
    validators: [T.RequiredNotEmptyListValidator],
    convertor: T.DefaultConvertor
  },
  {
    ...Container.containerNo,
    type: T.TextInput,
    example: '',
    default: '',
    value: '',
    validators: [],
    convertor: T.DefaultConvertor
  },
  {
    ...Job.assigneeId,
    type: T.TextInput,
    example: 'RII-12334',
    default: '',
    value: '',
    validators: [],
    convertor: T.DefaultConvertor
  },
  {
    type: T.TimeRange,
    key: 'createdTimeRange',
    label: 'Created Time',
    value: [],
    validators: [],
    convertor: T.DefaultConvertor
  }
]

export const JobTableHeaders = [
  {
    ...Job.no,
    type: T.Link,
    width: 80,
    linkKey: Job.no.key,
    link: 'goToJobDetail',
    sortable: 'custom',
    defaultSort: true
  },
  {
    ...Job.type,
    type: T.Tag,
    effect: 'dark',
    tagType: 'primary',
    sortable: 'custom'
  },
  {
    ...Job.status,
    type: T.Tag,
    effect: 'plain',
    tagType: e => {
      switch (e) {
        case JobStatus.JobDeleted:
          return 'danger'
        default:
          return null
      }
    },
    sortable: 'custom'
  },
  { ...Job.assigneeName, type: T.Text, sortable: 'custom' },
  { ...Job.createdTime, type: T.Time, sortable: 'custom' }
]

export const UnloadingJobTableHeaders = [
  {
    ...Job.no,
    type: T.Link,
    width: 80,
    linkKey: Job.no.key,
    link: 'goToJobDetail',
    sortable: 'custom',
    defaultSort: true
  },
  {
    ...Order.riiOrderNo,
    type: T.Link,
    width: 100,
    linkKey: 'orderNo',
    link: 'goToOrderDetail',
    sortable: 'custom'
  },
  {
    ...Container.no,
    width: 80,
    type: T.Link,
    key: 'riiContainerNo',
    col: 'rii_container_no',
    linkKey: 'orderNo',
    link: 'goToOrderDetail',
    sortable: 'custom'
  },
  { ...Container.containerNo, sortable: 'custom' },
  {
    ...Job.type,
    type: T.Tag,
    effect: 'plain',
    tagType: 'primary',
    width: 60,
    sortable: 'custom'
  },
  {
    ...Job.status,
    type: T.Tag,
    effect: 'plain',
    width: 60,
    tagType: e => {
      switch (e) {
        case JobDeleted:
          return 'info'
        case JobUnassigned:
          return 'danger'
        case JobAssigned:
        case JobProcessing:
          return 'primary'
        case JobCompleted:
          return 'success'
        default:
          return ''
      }
    },
    sortable: 'custom'
  },
  { ...Job.assigneeName, type: T.Text, sortable: 'custom' },
  { ...Job.createdTime, type: T.Time, sortable: 'custom' }
]

export const JobSearchParamsWrapUp = searchForm => {
  return T.DefaultWarpSearchForm(searchForm)
}

export const UnloadingJobVerificationFormHeader = [
  { label: 'Group Name', key: 'groupName', type: T.Text },
  { label: 'Estimated Counts', key: 'estimatedCounts', type: T.Number },
  { label: 'Actual Counts', key: 'actualCounts', type: T.NumberInput },
  { label: 'Pallet Counts', key: 'palletCounts', type: T.NumberInput }
]

export const MorePalletForm = [
  {
    label: 'Group Name',
    key: 'name',
    type: T.Text,
    span: 1,
    example: '',
    default: '',
    value: '',
    validators: []
  },
  {
    label: 'Previous Count',
    key: 'preCount',
    type: T.Text,
    span: 1,
    example: '',
    default: '',
    value: '',
    validators: []
  },
  {
    label: 'More Count',
    key: 'moreCount',
    type: T.NumberInput,
    min: 1,
    span: 1,
    example: 1,
    default: 1,
    value: 1,
    validators: [T.RequiredValidator]
  },
  {
    label: 'Append to Shipment',
    key: 'appendToShipment',
    type: T.Switch,
    activeText: 'Auto Append',
    inactiveText: 'None',
    span: 1,
    example: false,
    default: 1,
    value: false,
    validators: [T.RequiredValidator]
  }
]

export const AssignJobForm = [
  {
    label: 'Job No.',
    key: 'no',
    type: T.Text,
    span: 1,
    example: '',
    default: '',
    value: '',
    validators: []
  }
  // {
  //   ...JobAssignedItem
  // }
]
export const GoodsGroupModifyForm = [
  {
    key: 'address',
    label: 'Deliver Address',
    type: T.AddressSelect,
    value: null,
    validators: []
  },
  {
    ...GoodsGroup.name,
    type: T.TextInput,
    value: '',
    validators: [T.RequiredValidator],
    convertor: T.cleanString
  },
  {
    ...GoodsGroup.priority,
    type: T.Select,
    default: NormalPallet,
    value: '',
    validators: [T.RequiredValidator]
  },
  {
    label: 'Hold',
    key: 'hold',
    type: T.HoldSelect,
    value: '',
    validators: [T.RequiredValidator]
  }
]

export const SplitJobCreate = 'SplitJobCreate'
export const SplitJobModify = 'SplitJobModify'

export const SplitJobForm = Object.fromEntries(
  [
    {
      ...Job.type,
      span: 1,
      type: T.Tag,
      effect: 'dark',
      example: SplitPalletJob,
      default: SplitPalletJob,
      value: SplitPalletJob,
      validators: [T.RequiredValidator]
    },
    ...NoteForm
  ].map(one => [one.key, one])
)

export const SplitJobPackingListTableHeaders = [
  {
    ...Order.riiOrderNo,
    type: T.Link,
    width: 130,
    link: 'goToOrderDetail',
    defaultSort: true
  },
  {
    ...Pallet.no,
    type: T.Link,
    width: 100,
    linkKey: Pallet.no.key,
    link: 'goToPalletDetail',
    defaultSort: true
  },
  {
    ...Container.no,
    key: 'riiContainerNo',
    width: 80,
    label: 'Container'
  },
  {
    ...Pallet.groupName,
    width: 100
  },
  {
    ...Pallet.status,
    label: 'Status',
    type: T.Tag,
    effect: 'plain',
    tagType: e => {
      switch (e) {
        case PalletStatus.PalletUpcoming:
          return 'warning'
        case PalletStatus.PalletOffStack:
          return 'success'
        case PalletStatus.PalletDeleted:
          return 'info'
        default:
          return null
      }
    }
  },
  {
    ...Pallet.address,
    label: 'Dest',
    type: T.AddressTag,
    col: 'address_id'
  },
  {
    ...Pallet.quantity,
    type: T.Number,
    effect: 'dark',
    width: 70
  },
  {
    type: T.Text,
    label: 'Slot No.',
    key: 'slotNo',
    col: 'slot_no'
  }
]
